import type { EnrollmentCreateResponseOneOfFiveResult } from './enrollmentCreateResponseOneOfFiveResult';

export type EnrollmentCreateResponseOneOfFive = {
  /**
   * 예상 수강 가능 일자
   * @nullable
   */
  estimatedAvailableDate?: string | null;
  /**
   * 대기열 순번
   * @minimum 1
   */
  position: number;
  result: EnrollmentCreateResponseOneOfFiveResult;
};
